import { UserBuilder } from '../users/user-builder';
import { PresenceStatus } from './presence-status.enum';
var PresenceInfoBuilder = /** @class */ (function () {
    function PresenceInfoBuilder() {
        this.presenceInfo = {
            createdByUser: new UserBuilder().build(),
            lastUpdateDate: Date.now(),
            itemId: '12312312',
            presenceStatus: PresenceStatus.ONLINE,
            locale: 'en',
            text: ''
        };
    }
    PresenceInfoBuilder.prototype.withItemId = function (itemId) {
        this.presenceInfo.itemId = itemId;
        return this;
    };
    PresenceInfoBuilder.prototype.withLocale = function (locale) {
        this.presenceInfo.locale = locale;
        return this;
    };
    PresenceInfoBuilder.prototype.withCreatedByUser = function (createdByUser) {
        this.presenceInfo.createdByUser = createdByUser;
        return this;
    };
    PresenceInfoBuilder.prototype.withPresenceStatus = function (presenceStatus) {
        this.presenceInfo.presenceStatus = presenceStatus;
        return this;
    };
    PresenceInfoBuilder.prototype.withLastUpdateDate = function (lastUpdateDate) {
        this.presenceInfo.lastUpdateDate = lastUpdateDate;
        return this;
    };
    PresenceInfoBuilder.prototype.withText = function (text) {
        this.presenceInfo.text = text;
        return this;
    };
    PresenceInfoBuilder.prototype.build = function () {
        return this.presenceInfo;
    };
    return PresenceInfoBuilder;
}());
export { PresenceInfoBuilder };
//# sourceMappingURL=presence-info.builder.js.map